module.exports = __webpack_public_path__ + "img/TradingView-icon5.8028b7f1.svg";